import { gql } from "@apollo/client";
import { UserApplication, UserApplicationSessionEventType } from "../types";

export const userApplicationSessionEventFragment = gql`
  fragment userApplicationSessionEventFragment on user_application_session_event {
    id
    userProfileId: user_profile_id
    application
    itemId: item_id
    eventType: event_type
    createdAt: created_at
    userFullName: user_full_name
  }
`;

export interface UserApplicationSessionEvent {
  id: string;
  userProfileId: string;
  application: UserApplication;
  itemId: string;
  eventType: UserApplicationSessionEventType;
  createdAt: string;
  userFullName: string | null;
}

export default userApplicationSessionEventFragment;
